import type { BlogPageMetadata } from '$lib/types/BlogPageMetadata.ts';
import type { MetaTagsProps } from 'svelte-meta-tags';

import { PUBLIC_TWITTER_OG_WEBAPP_URL } from '$env/static/public';
import { OG_IMAGE_HEIGHT, OG_IMAGE_WIDTH } from '$lib/metatagInfo.ts';

import type { LayoutLoad } from './$types.ts';

import { BLOG_PAGES_DIRECTORY, type BlogPageSlug } from '../BLOG_PAGES_DIRECTORY.ts';

export const load: LayoutLoad = async ({ url }) => {
	let bpMetadata: BlogPageMetadata | null = null;

	try {
		const bpSlug = url.pathname.split('/').pop() as BlogPageSlug;
		bpMetadata = BLOG_PAGES_DIRECTORY[bpSlug];
	} catch (error) {
		return {
			error: new Error('Blog page not found'),
			status: 404
		};
	}

	if (!bpMetadata) {
		return {
			error: new Error('Blog page not found'),
			status: 404
		};
	}

	const metaTitle = `Tickrr | ${bpMetadata.title}`;
	const metaTags: MetaTagsProps = {
		canonical: url.href,
		description: bpMetadata.description,
		openGraph: {
			description: bpMetadata.description,
			images: [
				{
					alt: bpMetadata.title,
					height: OG_IMAGE_HEIGHT,
					url: `${PUBLIC_TWITTER_OG_WEBAPP_URL}${bpMetadata.headerImage}`,
					width: OG_IMAGE_WIDTH
				}
			],
			title: metaTitle,
			url: url.href
		},

		title: metaTitle,
		twitter: {
			cardType: 'summary_large_image',
			description: bpMetadata.description,
			handle: '@tickrr_io',
			image: `${PUBLIC_TWITTER_OG_WEBAPP_URL}${bpMetadata.headerImage}`,
			imageAlt: bpMetadata.title,
			site: '@tickrr_io',
			title: bpMetadata.title
		}
	};

	return {
		blogMetadata: bpMetadata,
		metaTags: Object.freeze(metaTags)
	};
};
